export default __webpack_public_path__ + "static/media/1_4.077845d4.png";